import { render } from "./addplot.vue?vue&type=template&id=5f1f8326"
import script from "./addplot.vue?vue&type=script&lang=js"
export * from "./addplot.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__